<template>
    <div>
        <section>
            <v-card-actions>
                <router-link to="/courses">
                    <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }"> Back </v-btn>
                </router-link>
            </v-card-actions>
            <h1>{{ card.title }}</h1>
            <!-- Título y subtítulo             
            <h3>{{ card.subtitle }}</h3>-->
            <v-divider></v-divider>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-row>
                <v-col cols="12" md="12" lg="12">
                    <v-img class="align-end text-white" contain :style="{ 'max-width': '180vh', 'max-height': '50vh' }" :src="getImageSrc(card.images)"></v-img>
                </v-col>
            </v-row>
            <v-row>                
                <v-col cols="12" md="6" lg="12">
                    <p style="font-size: 50px; color: rgb(15, 135, 201);"><b>________________________________________________</b></p>
                    <!---->
                    <details @click="mostrarAdjuntosCategories(4)" open>
                        <summary id="cat4">
                            <p><b>E-learning</b></p>
                        </summary>
                        <div>
                            <p>
                                <ul>
                                    <li>
                                        <a href="https://knowvawdata.com/course/" target="_blank">KNOwVAWdata</a> 
                                        on data on violence against women (UNFPA)
                                    </li>
                                    <li>
                                        <a href="https://www.unodc.org/e4j/en/index.html" target="_blank">Education for Justice</a>
                                        University Module Series –
                                        <a href="https://www.unodc.org/e4j/en/crime-prevention-criminal-justice/module-9/index.html" target="_blank">Gender in the Criminal Justice System</a> and 
                                        <a href="https://sherloc.unodc.org/cld/en/education/tertiary/cybercrime/module-12/index.html" target="_blank">Cybercrime Module 12 (unodc.org)</a>
                                    </li>
                                    <li>
                                        <a href="https://extranet.unfpa.org/Apps/VAW/" target="_blank">E-Learning course</a> Essential services package for women and girls subject to violence:
                                        <ul>
                                            <li>
                                                <a href="https://extranet.unfpa.org/Apps/VAW/Module1/story.html" target="_blank">Module 1:</a> Overview and Introduction 
                                                to the Essential Services Package for Women and Girls Subject to Violence
                                            </li>
                                            <li>
                                                <a href="https://extranet.unfpa.org/Apps/VAW/Module2/story.html" target="_blank">Module 2:</a> Essential Health Services for Women and Girls 
                                                Subject to Violence
                                            </li>
                                            <li>
                                                <a href="https://extranet.unfpa.org/Apps/VAW/Module3/story.html" target="_blank">Module 3:</a> Essential Justice and Policing Services for Women 
                                                and Girls Subject to Violence
                                            </li>
                                            <li>
                                                <a href="https://extranet.unfpa.org/Apps/VAW/Module4/story.html" target="_blank">Module 4:</a> Essential Social Services for Women and Girls Subject to Violence
                                            </li>
                                            <li>
                                                <a href="https://extranet.unfpa.org/Apps/VAW/Module5/story.html" target="_blank">Module 5:</a> Essential Action for Governance and Coordination of Governance
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        Our Bodies, Our Rights! Addressing Sexual and Reproductive Health and Rights and Gender-based Violence for Women and Young People with Disabilities. 
                                        Virtual Workshop Curriculum for Organizations of Persons with Disabilities - 
                                        <a @click="descargarCategory(4, 'WEI_documents_virtual_08_ACCESIBLE.pdf')" target="_blank" style="text-decoration: underline; color: var(--v-anchor-base);"> {{ 'EN' }} </a>
                                    </li>
                                    <li>
                                        E-learning course on Alternatives to Imprisonment for Women Offenders 
                                        <a href="https://www.unodc.org/elearning/en/courses/course-catalogue.html#gender" target="_blank">EN</a>
                                    </li>
                                    <li>
                                        <a href="https://golearn.unodc.org/lms/course/view.php?id=566" target="_blank">Access to Legal Aid for Women in Criminal Justice Systems (English - Interactive version)</a>
                                    </li>
                                    <li>
                                        <a href="https://golearn.unodc.org/lms/course/view.php?id=614" target="_blank">Access to Legal Aid for Women in Criminal Justice Systems (English - mobile-friendly version)</a>
                                    </li>
                                    <li>
                                        <a href="https://golearn.unodc.org/lms/course/view.php?id=608" target="_blank">Access to Legal Aid for Women in Criminal Justice Systems (French - Interactive version)</a>
                                    </li>
                                    <li>
                                        <a href="https://golearn.unodc.org/lms/course/view.php?id=615" target="_blank">Access to Legal Aid for Women in Criminal Justice Systems (French - mobile-friendly version)</a>
                                    </li>
                                    <li>
                                        <a href="https://golearn.unodc.org/lms/course/view.php?id=577" target="_blank">Implementing a Coordinated Criminal Justice Response to Gender-based Violence Against Women</a>
                                    </li>
                                    <li>
                                        <a href="https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fdocs.google.com%2Fspreadsheets%2Fd%2F1-68AEy6hwi3xG9UMRGp2IV5HLhIMUi7ycF0nX4qow_w%2Fedit%3Fusp%3Dsharing&data=02%7C01%7Cyasmine.didaoui%40un.org%7Cfb9b2af0bcbe4f3331b008d845be92db%7C0f9e35db544f4f60bdcc5ea416e6dc70%7C0%7C0%7C637336032120488857&sdata=qeshT17wiXePECFpSOQprWMtq6Wnpw5oCPxok9Tx1ec%3D&reserved=0" target="_blank">
                                        Repository of materials and promising practices on crime prevention and criminal justice responses to violence against 
                                        women identified by UNODC field offices </a>
                                    </li>
                                    <li>
                                        <a href="https://www.ecampus.iom.int/enrol/index.php?id=583" target="_blank">
                                            Course Mainstreaming Gender in IOM Border Management Programs 
                                        </a>
                                    </li>
                                    <li>
                                        Curso virtual paquete de servicios esenciales para mujeres y niñas que sufren violencia - 
                                        <a href="https://serviciosesencialesviolencia.org/courses/curso-virtual-paquete-de-servicios-esenciales-para-mujeres-y-ninas-que-sufren-violencia/" target="_blank">ES</a>
                                    </li>
                                    <li>
                                        Curso virtual de manejo clínico de sobrevivientes de violencia sexual y violencia de pareja - 
                                        <a href="https://serviciosesencialesviolencia.org/courses/curso-virtual-de-manejo-clinico-de-sobrevivientes-de-violencia-sexual-y-violencia-de-pareja/" target="_blank">ES</a>
                                    </li>
                                </ul>
                            </p>
                            <p>
                                <b>Networks and knowledge hubs</b><br>
                                <ul>
                                    <li>
                                        Latin America Spotlight Initiative Regional Programme’s 
                                        <a href="https://lac.unwomen.org/es/repositorio-de-productos-de-conocimiento-del-programa-regional-para-america-latina-de-la-iniciativa-spotlight" target="_blank">repository of knowlegde products</a>
                                    </li>
                                    <li>
                                        UN Women’s 
                                        <a href="http://www.endvawnow.org/en/articles/302-timeline-of-policy-commitments-and-international-agreements-.html" target="_blank">
                                            Virtual Knowledge Centre to End Violence against Women and Girls
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://gbvaor.net/" target="_blank">
                                            Gender-Based Violence Area of Responsibility (GBVA AoR)
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.gbvims.com/" target="_blank">
                                            Gender-based Violence Information Management System 
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://gbvresponders.org/" target="_blank">
                                            IRC's GBV Responders' Network 
                                        </a>
                                    </li>
                                    <li>
                                        <a href="http://preventgbvafrica.org/" target="_blank">
                                            The GBV Prevention Network  
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://gbvguidelines.org/en/knowledgehub/" target="_blank">
                                            The IASC GBV Guidelines Knowledge Hub
                                        </a>
                                    </li>
                                    <li>
                                        Prevenir Violencias de Género 
                                        <a href="https://www.prevenirviolenciasdegenerolac.org/" target="_blank">LAC</a> + 
                                        <a href="https://mapee.com.ar/ciscsa/prevenir/" target="_blank">map</a>
                                    </li>
                                    <li>                                        
                                        <a href="https://pdp.unfpa.org/" target="_blank">UNFPA Population Data Portal</a>
                                        (Violence Against Women data) 
                                    </li>
                                    <li>
                                        KNOwVAWdata
                                        <a href="https://knowvawdata.com/knowledge-hub/" target="_blank">knowledge hub</a>
                                    </li>
                                    <li>
                                        <a href="https://childmarriagedata.org/" target="_blank">Child marriage data</a>
                                    </li>
                                    <li>
                                        UNWomen 
                                        <a href="https://data.unwomen.org/data-portal/vaw-wps?annex=Violence%20Against%20Women&finic%5B%5D=SH_STA_FGMS&fiac%5BSH_STA_FGMS%5D%5B%5D=15-49&fiwq%5BVAW-3%5D%5B%5D=All&filc%5BVAW-3%5D%5B%5D=Urban&fiac%5BVC_VAW_MARR%5D%5B%5D=15-49&fiac%5BVC_VAW_SXVLN%5D%5B%5D=18-29&fiac%5BVAW-1%5D%5B%5D=50-64&fiac%5BVC_HTF_DETVOP%5D%5B%5D=18%2B&fiac%5BVC_HTF_DETVFL%5D%5B%5D=18%2B&fyr%5B%5D=Latest%20available&fsr=countries&tab=map" target="_blank">VAW data portal </a>
                                    </li>
                                    <li>                                        
                                        <a href="https://prevention-collaborative.org/knowledge-hub/" target="_blank">Prevention collaborative Knowledge Hub</a>
                                    </li>
                                    <li>
                                        <a href="https://www.svri.org/" target="_blank">Sexual Violence Research Initiative (SVRI)</a>
                                    </li>
                                </ul>
                            </p>
                        </div>
                    </details>
                </v-col>
            </v-row>
        </section>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {            
            nombresAdjuntos: [], nombresAdjuntos2: [], nombresAdjuntos3: [], nombresAdjuntos4: [],
            nombresAdjuntosSub1: [], nombresAdjuntosSub2: [], nombresAdjuntosSub3: [], nombresAdjuntosSub4: [], nombresAdjuntosSub5: [],
            nombresAdjuntosSub6: [], nombresAdjuntosSub7: [], nombresAdjuntosSub8: [], nombresAdjuntosSub9: [],
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                additionalInfo2: '',
                images: [],
                chip: [],
            },
            cards: [
                {
                    id: 5,
                    title: 'GENDER-BASED VIOLENCE',
                    subtitle: 'UNODC',
                    category: '<p><b></p></b>'+
                        '<ul>'+
                            '<li><a href="#cat5" style="text-decoration: none;">5.0 Gender-Based Violence</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat5_1" style="text-decoration: none;">5.0.1. Definitions</a></li>'+
                                    '<li><a href="#cat5_3" style="text-decoration: none;">5.0.2. Tools and Resources</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat1" style="text-decoration: none;">5.1. Global Norms and Standards</a></li>'+
                            '<li><a href="#cat2" style="text-decoration: none;">5.2. UN Response</a></li>'+
                            '<li><a href="#cat3" style="text-decoration: none;">5.3. Thematic Areas</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat3_1" style="text-decoration: none;">5.3.1. GBV Prevention - Tools and Resources</a></li>'+
                                    '<li><a href="#cat3_2" style="text-decoration: none;">5.3.2. Attention to GBV survivors - Tools and Resources</a></li>'+
                                    '<li><a href="#cat3_3" style="text-decoration: none;">5.3.3. Femicide and homicide due to gender - Tools and Resources</a></li>'+
                                    '<li><a href="#cat3_4" style="text-decoration: none;">5.3.4. Justice Administration and access to justice with a gender perspective - Tools and Resources</a></li>'+
                                    '<li><a href="#cat3_5" style="text-decoration: none;">5.3.5. Public policies with an intersectional perspective - Tools and Resources</a></li>'+
                                    '<li><a href="#cat3_6" style="text-decoration: none;">5.3.6. Data and statistics disaggregated by sex and gender identity - Tools and Resources</a></li>'+
                                    '<li><a href="#cat3_7" style="text-decoration: none;">5.3.7. GBV generated by technology - Tools and Resources</a></li>'+
                                    '<li><a href="#cat3_8" style="text-decoration: none;">5.3.8. Sexual violence - Tools and Resources</a></li>'+
                                    '<li><a href="#cat3_9" style="text-decoration: none;">5.3.9. Harmful practices - Tools and Resources</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat4" style="text-decoration: none;">5.4. E-learning</a></li>'+
                        '</ul>',
                    additionalInfo: 'Additional Info',
                    additionalInfo2: '',
                    description: '',                    
                    images: ['5.jpg'],                    
                    chip: ['8:00 AM', '10:00 AM', '2:00 PM', '4:00 PM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                },
            ],
        };  
    },
    methods: {
        descargarArchivo(nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarGender/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarGender/${nombreArchivo}`;//local
            
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target', '_blank'); // Para abrir el archivo en una nueva pestaña
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        descargarCategory(id, nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarSoporte5/${id}/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte5/${id}/${nombreArchivo}`;//local
            // Extraer la extensión del archivo
            const extension = nombreArchivo.split('.').pop().toLowerCase();

            // Crear una solicitud HTTP
            const xhr = new XMLHttpRequest();

            // Configurar la solicitud
            xhr.open('GET', url, true);
            xhr.responseType = 'blob'; // Establecer el tipo de respuesta como blob (Binary Large Object)

            // Configurar la gestión de la carga
            xhr.onload = function () {
                if (xhr.status === 200) {
                    // Crear un objeto Blob con el contenido de la respuesta
                    const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

                    // Verificar la extensión del archivo
                    if (extension === 'pdf') {
                        // Si es un PDF, abrir en una nueva pestaña
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute('target', '_blank');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // Para otras extensiones, descargar
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = nombreArchivo;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            };

            // Enviar la solicitud
            xhr.send();
        },
        // Función para obtener y mostrar los nombres de archivo de los adjuntos del proceso
        async mostrarAdjuntosCategories(id) {
            try {
                const response = await axios.get(`api/Categories/MostrarCategoriesGender/${id}`);
                switch (id) {
                    case 1:
                        this.nombresAdjuntos = response.data;
                        break;
                    case 2:
                        this.nombresAdjuntos2 = response.data;
                        break;
                    case 3:
                        this.nombresAdjuntos3 = response.data;
                        break;
                    case 4:
                        this.nombresAdjuntos4 = response.data;
                        break;
                    default:
                        console.error("ID no válido:", id);
                        break;
                }
            } catch (error) {
                console.error(error);
                return []; // En caso de error, devuelve una lista vacía o realiza otra acción adecuada
            }
        },
        // Función para obtener y mostrar los nombres de archivo de los adjuntos del proceso
        async mostrarAdjuntosSubCategories(id, id2) {
            try {
                const response = await axios.get(`api/Categories/MostrarSubCategoriesGender/${id}/${id2}`);
                switch (id2) {
                    case 1:
                        this.nombresAdjuntosSub1 = response.data;
                        break;
                    case 2:
                        this.nombresAdjuntosSub2 = response.data;
                        break;
                    case 3:
                        this.nombresAdjuntosSub3 = response.data;
                        break;
                    case 4:
                        this.nombresAdjuntosSub4 = response.data;
                        break;
                    case 5:
                        this.nombresAdjuntosSub5 = response.data;
                        break;
                    case 6:
                        this.nombresAdjuntosSub6 = response.data;
                        break;
                    case 7:
                        this.nombresAdjuntosSub7 = response.data;
                        break;
                    case 8:
                        this.nombresAdjuntosSub8 = response.data;
                        break;
                    case 9:
                        this.nombresAdjuntosSub9 = response.data;
                        break;
                    default:
                        console.error("ID no válido:", id);
                        break;
                }
            } catch (error) {
                console.error(error);
                this.nombresAdjuntosSub1 = []; // En caso de error, devuelve una lista vacía o realiza otra acción adecuada
            }
        },
        descargarSubCategory(id, id2, nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarSoporte5_1/${id}/${id2}/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte5_1/${id}/${id2}/${nombreArchivo}`;//local
            // Extraer la extensión del archivo
            const extension = nombreArchivo.split('.').pop().toLowerCase();

            // Crear una solicitud HTTP
            const xhr = new XMLHttpRequest();

            // Configurar la solicitud
            xhr.open('GET', url, true);
            xhr.responseType = 'blob'; // Establecer el tipo de respuesta como blob (Binary Large Object)

            // Configurar la gestión de la carga
            xhr.onload = function () {
                if (xhr.status === 200) {
                    // Crear un objeto Blob con el contenido de la respuesta
                    const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

                    // Verificar la extensión del archivo
                    if (extension === 'pdf') {
                        // Si es un PDF, abrir en una nueva pestaña
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute('target', '_blank');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // Para otras extensiones, descargar
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = nombreArchivo;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            };

            // Enviar la solicitud
            xhr.send();
        },
        
        /*
        async listar() {
            try {
                const response = await axios.get('api/Publication/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },*/
        getImageSrc(filename) {
            return require(`../../assets/${filename}`);
        },
    },
    created() {
        const cardId = parseInt(this.$route.params.id);
        this.card = this.cards.find(card => card.id === cardId);
    },
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 16px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    details { 
        background-color: #f6f8fa;
        width: 100%;
        margin-bottom: 1rem;   
        border-radius: 8px;  
        border: 1px solid #d8e0e9;
        color: #364f6b;
        position: relative;  
    }
    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: 0.5em;
    }
    details summary {  
        font-weight: 400;
        font-size: 1.25rem;
        padding: 1rem;
        cursor: pointer;
        list-style: none;
    }
    details summary::before {
        content: "▶"; /* Flecha hacia la derecha */
        font-size: 1.5rem;
        line-height: 1.5rem;
        color: #364f6b;
        position: absolute;
        left: 97%; /* Ajusta el espacio entre la flecha y el texto */
    }
    details[open] summary::before {
        content: "▼"; /* Flecha hacia abajo cuando details está abierto */
    }    
    .document-columns {
        columns: 2; /* Divide la lista en dos columnas */
        column-gap: 20px; /* Espacio entre las columnas */
    }
</style>